import React from 'react';
import { Calendar as CalendarIcon, Clock, MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const UpcomingEvents = ({ events }) => {
    const upcomingEvents = events
        .filter(event => new Date(event.startDate) >= new Date())
        .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
        .slice(0, 8); // Show more events in the horizontal scroll

    const EVENT_COLORS = [
        {
            card: 'bg-gradient-to-br from-blue-50 to-white border-blue-200',
            text: 'text-blue-800',
            date: 'bg-blue-100',
            tag: 'bg-blue-100/80 text-blue-800'
        },
        {
            card: 'bg-gradient-to-br from-green-50 to-white border-green-200',
            text: 'text-green-800',
            date: 'bg-green-100',
            tag: 'bg-green-100/80 text-green-800'
        },
        {
            card: 'bg-gradient-to-br from-pink-50 to-white border-pink-200',
            text: 'text-pink-800',
            date: 'bg-pink-100',
            tag: 'bg-pink-100/80 text-pink-800'
        },
        {
            card: 'bg-gradient-to-br from-purple-50 to-white border-purple-200',
            text: 'text-purple-800',
            date: 'bg-purple-100',
            tag: 'bg-purple-100/80 text-purple-800'
        },
        {
            card: 'bg-gradient-to-br from-yellow-50 to-white border-yellow-200',
            text: 'text-yellow-800',
            date: 'bg-yellow-100',
            tag: 'bg-yellow-100/80 text-yellow-800'
        },
        {
            card: 'bg-gradient-to-br from-indigo-50 to-white border-indigo-200',
            text: 'text-indigo-800',
            date: 'bg-indigo-100',
            tag: 'bg-indigo-100/80 text-indigo-800'
        }
    ];

    const getEventTypeColor = () => {
        const randomIndex = Math.floor(Math.random() * EVENT_COLORS.length);
        return EVENT_COLORS[randomIndex];
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            timeZone: 'America/Antigua', month: 'short',
            day: 'numeric',
        });
    };

    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            timeZone: 'America/Antigua', hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    };

    if (upcomingEvents.length === 0) {
        return (
            <div className="p-6 text-center text-gray-500">
                No upcoming events scheduled
            </div>
        );
    }

    return (
        <div className="w-full">
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Upcoming Events</h2>
                <Link 
                    to="/calendar" 
                    className="flex items-center text-purple-600 hover:text-purple-700 transition-colors duration-200"
                >
                    View Calendar
                    <ArrowRight className="w-4 h-4 ml-1" />
                </Link>
            </div>
            <div className="relative">
                <div className="overflow-x-auto pb-4 hide-scrollbar">
                    <div className="flex space-x-4">
                        {upcomingEvents.map((event, index) => {
                            const colors = getEventTypeColor();
                            return (
                                <div
                                    key={event.id || index}
                                    className={`flex-shrink-0 w-72 rounded-xl border ${colors.card} p-4 shadow-sm 
                                              hover:shadow-md transition-all duration-300 cursor-pointer`}
                                    onClick={() => window.location.href = '/calendar'}
                                >
                                    <div className="flex items-start justify-between mb-3">
                                        <div className={`px-3 py-1 rounded-lg ${colors.date}`}>
                                            <CalendarIcon className={`w-4 h-4 ${colors.text} inline mr-1`} />
                                            <span className={`text-sm font-medium ${colors.text}`}>
                                                {formatDate(event.startDate)}
                                            </span>
                                        </div>
                                        <span className={`px-2.5 py-1 rounded-lg text-xs font-medium ${colors.tag}`}>
                                            {event.type || 'Event'}
                                        </span>
                                    </div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                                        {event.title}
                                    </h3>
                                    <div className="space-y-2">
                                        <div className="flex items-center text-gray-600">
                                            <Clock className="w-4 h-4 mr-2" />
                                            <span className="text-sm">{event.dateLabel || formatTime(event.startDate)}</span>
                                        </div>
                                        {event.location && (
                                            <div className="flex items-center text-gray-600">
                                                <MapPin className="w-4 h-4 mr-2" />
                                                <span className="text-sm line-clamp-1">{event.location}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpcomingEvents;
